(function () {
  var roots = document.querySelectorAll('[data-col-bestsellers]');
  if (!roots.length) return;

  var rows = [
    '.product-card__media',
    '.product-title',
    '.col-bestsellers__blurb',
    '.col-bestsellers__facts'
  ];

  function equalizeRows(root) {
    var cards = Array.from(root.querySelectorAll('.col-bestsellers__card--product'));
    if (cards.length < 2) return;

    rows.forEach(function (sel) {
      var els = [];
      cards.forEach(function (card) {
        var el = card.querySelector(sel);
        if (el) {
          el.style.minHeight = '';
          els.push(el);
        }
      });
      if (els.length < 2) return;

      var max = 0;
      els.forEach(function (el) {
        var h = el.getBoundingClientRect().height;
        if (h > max) max = h;
      });

      els.forEach(function (el) {
        el.style.minHeight = Math.ceil(max) + 'px';
      });
    });
  }

  roots.forEach(function (root) {
    var container = root.querySelector('.col-bestsellers__container');
    var track     = root.querySelector('.col-bestsellers__track');
    var cards     = Array.from(root.querySelectorAll('.col-bestsellers__card'));
    var btnLeft   = root.querySelector('.col-bestsellers__nav--left');
    var btnRight  = root.querySelector('.col-bestsellers__nav--right');

    function runEqualize() { equalizeRows(root); }

    var imgs = Array.from(root.querySelectorAll('.col-bestsellers__card--product img'));
    var loaded = 0;
    if (imgs.length) {
      imgs.forEach(function (img) {
        if (img.complete) {
          loaded++;
        } else {
          img.addEventListener('load', function () {
            loaded++;
            if (loaded >= imgs.length) runEqualize();
          }, { once: true });
        }
      });
      if (loaded >= imgs.length) runEqualize();
    } else {
      runEqualize();
    }

    if (!container || !track || cards.length === 0 || !btnLeft || !btnRight) return;

    var productCards = Array.from(root.querySelectorAll('.col-bestsellers__card--product'));
    if (!productCards.length) return;

    function getStep() {
      var gap = parseFloat(getComputedStyle(track).gap) || 12;
      return productCards[0].offsetWidth + gap;
    }

    function hasOverflowX() {
      return track.scrollWidth - track.clientWidth > 1;
    }

    function updateArrows() {
      var scrollable = hasOverflowX();
      root.classList.toggle('has-scroll', scrollable);
      btnLeft.classList.toggle('is-disabled', !scrollable || track.scrollLeft <= 1);
      btnRight.classList.toggle('is-disabled', !scrollable || track.scrollLeft >= track.scrollWidth - track.clientWidth - 1);
    }

    var scrollEndTimer;
    function onTrackScroll() {
      clearTimeout(scrollEndTimer);
      scrollEndTimer = setTimeout(updateArrows, 100);
    }

    btnRight.addEventListener('click', function () {
      track.scrollBy({ left: getStep(), behavior: 'smooth' });
    });
    btnLeft.addEventListener('click', function () {
      track.scrollBy({ left: -getStep(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', onTrackScroll, { passive: true });
    window.addEventListener('resize', updateArrows, { passive: true });
    Array.from(track.querySelectorAll('img')).forEach(function (img) {
      img.addEventListener('load', updateArrows, { once: true });
    });

    updateArrows();
  });

  var debounce;
  window.addEventListener('resize', function () {
    clearTimeout(debounce);
    debounce = setTimeout(function () {
      roots.forEach(equalizeRows);
    }, 150);
  }, { passive: true });
})();
